import useUriFragment from './useUriFragment';

const emptyTabsArray = [];

const useConditionalTabHash = tabs => {
  const hasMultipleTabs = tabs.length > 1;
  const tabsForHash = hasMultipleTabs ? tabs : emptyTabsArray;
  const [activeTab, setActiveTab] = useUriFragment(tabsForHash);

  const actualActiveTab = hasMultipleTabs && activeTab ? activeTab : tabs[0].value;

  return {
    activeTab: actualActiveTab,
    setActiveTab,
    hasMultipleTabs
  };
};

export default useConditionalTabHash;
